import { TSortableColumn } from '../../Components/GenericTable/types';

export const candidatePoolAssignmentColumns: TSortableColumn[] = [
  { id: 'name', label: 'Name', sortable: true, canToggle: true, enabled: true },
  { id: 'position', label: 'Position', sortable: false, canToggle: true, enabled: true },
  { id: 'location', label: 'Location', sortable: false, canToggle: true, enabled: true },
  { id: 'emails', label: 'Emails', sortable: false, canToggle: true, enabled: true },
  { id: 'phones', label: 'Phones', sortable: false, canToggle: true, enabled: true }
];

export const headerStyles = (id: string, tableHovered: boolean) => ({
  backgroundColor: tableHovered ? '#f5f5f5' : '#ffffff',
  fontWeight: 600,
  fontSize: '14px',
  color: '#333333',
  borderBottom: '1px solid #e0e0e0',
  padding: '12px 16px'
});
